import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    BuyerOrderStatus,
    IAmendBuyerOrderRequest,
    IBuyerOrder,
    IBuyerOrderLineRequest,
    IBuyerOrderPage,
    IBuyerOrderStatusRequest,
    ICreateBuyerOrderRequest,
    IUpdateBuyerOrderRequest,
} from '../interfaces/garments/buyerOrder.interface';

const headers = () => AuthService.getAuthHeader();

export const BuyerOrderService = {
    list: async (
        institutionId: string,
        page = 0,
        size = 20,
        buyerId?: string,
        status?: BuyerOrderStatus,
        shipFrom?: string,
        shipTo?: string,
        agentPartyId?: string,
        includeCancelled = false
    ): Promise<IBuyerOrderPage> => {
        const res = await axios.get(ENDPOINTS.BUYER_ORDER.LIST(institutionId), {
            headers: headers(),
            params: { page, size, buyerId, status, shipFrom, shipTo, agentPartyId, includeCancelled },
        });
        return res.data;
    },

    getById: async (institutionId: string, id: string): Promise<IBuyerOrder> => {
        const res = await axios.get(ENDPOINTS.BUYER_ORDER.GET(institutionId, id), { headers: headers() });
        return res.data;
    },

    create: async (institutionId: string, request: ICreateBuyerOrderRequest): Promise<IBuyerOrder> => {
        const res = await axios.post(ENDPOINTS.BUYER_ORDER.CREATE(institutionId), request, { headers: headers() });
        return res.data;
    },

    update: async (institutionId: string, id: string, request: IUpdateBuyerOrderRequest): Promise<IBuyerOrder> => {
        const res = await axios.put(ENDPOINTS.BUYER_ORDER.UPDATE(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    replaceLines: async (institutionId: string, id: string, requests: IBuyerOrderLineRequest[]): Promise<IBuyerOrder> => {
        const res = await axios.put(
            ENDPOINTS.BUYER_ORDER.REPLACE_LINES(institutionId, id),
            { lines: requests },
            { headers: headers() }
        );
        return res.data;
    },

    amend: async (institutionId: string, id: string, request: IAmendBuyerOrderRequest): Promise<IBuyerOrder> => {
        const res = await axios.patch(ENDPOINTS.BUYER_ORDER.AMEND(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    changeStatus: async (institutionId: string, id: string, request: IBuyerOrderStatusRequest): Promise<IBuyerOrder> => {
        const res = await axios.patch(ENDPOINTS.BUYER_ORDER.CHANGE_STATUS(institutionId, id), request, { headers: headers() });
        return res.data;
    },
};
